<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">* {{ responseError }}</span>
              </v-flex>
              <v-flex sm6>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    label="Order Date"
                    type="text"
                    prepend-icon="event"
                    v-model="orderDate"
                  ></v-text-field>
                  <v-date-picker v-model="orderDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="
                    (user.roleName == 'WAREHOUSE_MANAGER' || user.role.roleName == 'WAREHOUSE_STAFF') && !!orderHeader.id
                  "
                >
                  <v-text-field
                    slot="activator"
                    label="Customer Request Date"
                    type="text"
                    prepend-icon="event"
                    v-model="csRequestDate"
                    readonly
                    :rules="rules.csRequestDateRules"
                  ></v-text-field>
                  <v-date-picker
                    v-model="csRequestDate"
                    :rules="rules.csRequestDateRules"
                    :min="orderDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6>
                <v-select
                  :items="shopList"
                  v-model="orderHeader.shopId"
                  label="Choose Shop"
                  item-text="name"
                  item-value="id"
                  @change="getRegionbyShop"
                  menu-props="auto"
                  :disabled="warehousebtnDisabled"
                  :readonly="user.role.roleName == 'BRANCH_ADMIN'"
                  :rules="rules.shopRules"
                ></v-select>
              </v-flex>
              <v-flex sm6>
                <v-layout row>
                  <v-text-field
                    prepend-icon="people"
                    label="Customer Name"
                    placeholder="Customer Name"
                    v-model="orderHeader.customerDTO.name"
                    @click.stop="orderHeader.shopId ? showCustomers() : ''"
                    :rules="rules.customerIdRules"
                    hint="Please choose shop first."
                    :disabled="
                      user.roleName == 'WAREHOUSE_MANAGER' &&
                      !!orderHeader.id &&
                      !orderHeader.shopId
                    "
                  ></v-text-field>
                  <v-btn color="primary" @click="addNewCustomer">
                    New Customer
                    <v-icon right>add_circle</v-icon>
                  </v-btn>
                </v-layout>
              </v-flex>
              <v-flex sm6>
                <v-select
                  :items="warehouseList"
                  v-model="orderHeader.warehouseId"
                  label="Warehouse"
                  item-text="name"
                  item-value="id"
                  readonly
                  @change="clearOrderDetail()"
                  :disabled="warehousebtnDisabled"
                  :rules="[
                    () => !!orderHeader.warehouseId || 'Warehouse is required',
                  ]"
                ></v-select>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="orderNo"
                  label="Order No"
                  v-model="orderHeader.orderNo"
                  type="text"
                  :rules="rules.orderNoRules(255, 'Order No')"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="phoneNo"
                  label="Phone Number"
                  v-model="orderHeader.phoneNo"
                  type="text"
                  :readonly="
                    (user.roleName == 'WAREHOUSE_MANAGER' || user.roleName == 'WAREHOUSE_STAFF') && !!orderHeader.id
                  "
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="deliveryAddress"
                  label="Delivery Address"
                  v-model="orderHeader.deliveryAddress"
                  type="text"
                  :rules="rules.orderAddressRules"
                  :readonly="
                    (user.roleName == 'WAREHOUSE_MANAGER' || user.roleName == 'WAREHOUSE_STAFF') && !!orderHeader.id
                  "
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="orderHeader.cityId"
                  :items="cityList"
                  color="blue-grey lighten-2"
                  label="Choose City..."
                  item-text="name"
                  menu-props="auto"
                  item-value="id"
                  :rules="rules.cityIdRules"
                  @change="getTownshipByCityId(orderHeader.cityId)"
                  :readonly="
                    (user.roleName == 'WAREHOUSE_MANAGER' || user.roleName == 'WAREHOUSE_STAFF') && !!orderHeader.id
                  "
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="billingAddress"
                  label="Billing Address"
                  v-model="orderHeader.billingAddress"
                  type="text"
                  :rules="rules.orderAddressRules"
                  :readonly="
                    (user.roleName == 'WAREHOUSE_MANAGER' || user.roleName == 'WAREHOUSE_STAFF') && !!orderHeader.id
                  "
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="orderHeader.townshipId"
                  :items="townshipList"
                  color="blue-grey lighten-2"
                  label="Choose Township..."
                  item-text="name"
                  menu-props="auto"
                  item-value="id"
                  :rules="rules.townshipIdRules"
                  :readonly="
                    (user.roleName == 'WAREHOUSE_MANAGER' || user.roleName == 'WAREHOUSE_STAFF') && !!orderHeader.id
                  "
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="remark"
                  label="Remark"
                  v-model="orderHeader.remark"
                  type="text"
                  :rules="rules.remarkRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="
                    (user.roleName == 'WAREHOUSE_MANAGER' || user.role.roleName == 'WAREHOUSE_STAFF') && !!orderHeader.id
                  "
                >
                  <v-text-field
                    slot="activator"
                    label="Estimated Delivery Date"
                    type="text"
                    prepend-icon="event"
                    v-model="estDate"
                    readonly
                    :rules="rules.estDateRules"
                  ></v-text-field>
                  <v-date-picker
                    v-model="estDate"
                    :rules="rules.estDateRules"
                    :min="orderDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="adminRemark"
                  label="Admin Remark"
                  v-model="orderHeader.adminRemark"
                  type="text"
                  :rules="rules.remarkRules"
                  :readonly="
                    (user.roleName == 'WAREHOUSE_MANAGER' || user.roleName == 'WAREHOUSE_STAFF') && !!orderHeader.id
                  "
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-layout row>
                  <v-flex sm4>
                    <v-text-field
                      v-if="!isDiscountPercentage"
                      v-model="orderHeader.discountAmount"
                      label="Discount Amount"
                      type="number"
                      min="0"
                      oninput="this.value = Math.abs(this.value)"
                      :readonly="
                        (user.roleName == 'WAREHOUSE_MANAGER' || user.roleName == 'WAREHOUSE_STAFF') && !!orderHeader.id
                      "
                    ></v-text-field>
                    <v-text-field
                      v-else
                      v-model="orderHeader.discountPercent"
                      label="Discount (%)"
                      type="number"
                      min="0"
                      :readonly="
                        (user.roleName == 'WAREHOUSE_MANAGER' || user.roleName == 'WAREHOUSE_STAFF') && !!orderHeader.id
                      "
                      :rules="rules.discountPercentRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm2>
                    <v-switch
                      v-model="isDiscountPercentage"
                      :label="`${isDiscountPercentage ? '% ON' : '% OFF'}`"
                      hide-details
                      @change="changeDiscountSwitch()"
                      small
                      :disabled="
                        btnDisabled ||
                        ((user.roleName == 'WAREHOUSE_MANAGER' || user.roleName == 'WAREHOUSE_STAFF') &&
                          !!orderHeader.id)
                      "
                    ></v-switch>
                  </v-flex>

                  <v-flex sm4>
                    <v-text-field
                      v-if="!isPromotionPercentage"
                      v-model="orderHeader.promotionAmount"
                      label="Promotion Amount"
                      type="number"
                      min="0"
                      oninput="this.value = Math.abs(this.value)"
                      :readonly="
                        (user.roleName == 'WAREHOUSE_MANAGER' || user.roleName == 'WAREHOUSE_STAFF') && !!orderHeader.id
                      "
                    ></v-text-field>
                    <v-text-field
                      v-else
                      v-model="orderHeader.promotionPercent"
                      label="Promotion (%)"
                      type="number"
                      min="0"
                      :readonly="
                        (user.roleName == 'WAREHOUSE_MANAGER' || user.roleName == 'WAREHOUSE_STAFF') && !!orderHeader.id
                      "
                      :rules="rules.promotionPercentRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm2>
                    <v-switch
                      v-model="isPromotionPercentage"
                      :label="`${isPromotionPercentage ? '% ON' : '% OFF'}`"
                      hide-details
                      @change="changePromotionSwitch()"
                      small
                      :disabled="
                        btnDisabled ||
                        ((user.roleName == 'WAREHOUSE_MANAGER' || user.roleName == 'WAREHOUSE_STAFF') &&
                          !!orderHeader.id)
                      "
                    ></v-switch>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  v-model="orderHeader.deliveryFee"
                  label="Delivery Fee"
                  type="number"
                  min="0"
                  oninput="this.value = Math.abs(this.value)"
                  :readonly="
                    (user.roleName == 'WAREHOUSE_MANAGER' || user.roleName == 'WAREHOUSE_STAFF') && !!orderHeader.id
                  "
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="orderHeader.id">
                <v-autocomplete
                  v-model="status"
                  :items="statusList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Status..."
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  :rules="rules.statusRules"
                  :readonly="
                    (user.roleName == 'WAREHOUSE_MANAGER' ||
                      user.roleName == 'SALE' || user.roleName == 'WAREHOUSE_STAFF') &&
                    !!orderHeader.id
                  "
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6 v-if="orderHeader.id">
                <v-text-field
                  label="Created By"
                  v-model="orderHeader.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="orderHeader.id">
                <v-text-field
                  label="Updated By"
                  v-model="orderHeader.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="orderHeader.id">
                <v-layout row wrap>
                  <v-flex sm12>
                    <v-menu
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :disabled="true"
                    >
                      <v-text-field
                        slot="activator"
                        label="Created Date"
                        type="text"
                        prepend-icon="event"
                        v-model="createdDate"
                        readonly
                      ></v-text-field>
                      <v-date-picker v-model="createdDate"></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex sm12>
                    <v-menu
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :disabled="true"
                    >
                      <v-text-field
                        slot="activator"
                        label="Updated Date"
                        type="text"
                        prepend-icon="event"
                        v-model="updatedDate"
                        readonly
                      ></v-text-field>
                      <v-date-picker v-model="updatedDate"></v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
              </v-flex>
              <!--<v-flex sm6>
                <v-flex v-if="orderHeader.id">
                  <v-switch
                    :label="`Save Direct Sale`"
                    :value="saveWholeSale"
                    v-model="saveWholeSale"
                  ></v-switch>
                </v-flex>
              </v-flex>-->
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear" :disabled="btnDisabled">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :readonly="!valid"
                    type="submit"
                    :disabled="btnDisabled"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-btn
                    color="success"
                    @click="addProduct()"
                    :disabled="
                      btnDisabled ||
                      ((user.roleName == 'WAREHOUSE_MANAGER' || user.roleName == 'WAREHOUSE_STAFF') && !!orderHeader.id)
                    "
                  >
                    Add Product
                    <v-icon right>add</v-icon>
                  </v-btn>
                  <v-flex sm2>
                    <v-switch
                      v-model="isItemDiscount"
                      label="discount"
                      :readonly="user.role.roleName == 'WAREHOUSE_MANAGER' || user.role.roleName == 'WAREHOUSE_STAFF'"
                    ></v-switch>
                  </v-flex>
                </v-layout>

                <!-- details table -->
                <v-card>
                  <v-card-title>
                    <v-flex xs4>
                      <v-text-field
                        v-model="detailCodeSearch"
                        append-icon="search"
                        placeholder="Enter product code"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-card-title>

                  <v-data-table
                    :headers="detailHeaders"
                    :items="detailList"
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <!-- product code -->
                      <td
                        v-if="
                          ((user.roleName == 'WAREHOUSE_MANAGER' || user.roleName == 'WAREHOUSE_STAFF') &&
                          !!orderHeader.id &&
                          !orderHeader.shopId) || !props.item.isNew
                        "
                      >
                        <span v-if="props.item.productDTO.code">
                          {{ props.item.productDTO.code }}
                        </span>
                        <span v-else> Select code </span>
                      </td>
                      <td
                        v-else
                        @click="
                          orderHeader.shopId &&
                          orderHeader.warehouseId &&
                          orderHeader.customerId
                            ? showProducts()
                            : '',
                            (selectedId = props.item.id)
                        "
                      >
                        <span v-if="props.item.productDTO.code">
                          <a>{{ props.item.productDTO.code }}</a>
                        </span>
                        <span v-else>
                          <span
                            v-if="
                              !orderHeader.shopId || !orderHeader.warehouseId
                            "
                          >
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <span v-on="on">
                                  <a>Select code</a>
                                </span>
                              </template>
                              <span
                                >Please choose shop and warehouse and customer
                                first.</span
                              >
                            </v-tooltip>
                          </span>
                          <span v-else>
                            <a>Select code</a>
                          </span>
                        </span>
                      </td>

                      <!-- product name -->
                      <td>
                        {{ props.item.productName }}
                      </td>

                      <!-- factor unit -->
                      <td>
                        <div style="width: 100px">
                          <v-autocomplete
                            dense
                            v-model="props.item.factorUnitName"
                            :hide-no-data="true"
                            :items="props.item.productUnits"
                            color="blue-grey lighten-2"
                            item-value="factorUnitName"
                            item-text="factorUnitName"
                            menu-props="auto"
                            @change="
                              (option) => initPrice(option, props.item.id)
                            "
                            :rules="rules.unitRules"
                            :readonly="
                              ((user.roleName == 'WAREHOUSE_MANAGER' || user.roleName == 'WAREHOUSE_STAFF') &&
                              !!orderHeader.id) || !props.item.isNew
                            "
                          ></v-autocomplete>
                        </div>
                      </td>

                      <!-- available qty -->
                      <!--<td>
                        {{ props.item.availableQty | decFormat(6) }}
                      </td>-->

                      <!-- order qty -->
                      <td>
                        <div style="width: 70px">
                          <v-text-field
                            v-model="props.item.orderQty"
                            min="0"
                            :rules="rules.qtyRules"
                            :readonly="
                              (user.roleName == 'WAREHOUSE_MANAGER' || user.roleName == 'WAREHOUSE_STAFF') &&
                              !!orderHeader.id
                            "
                          ></v-text-field>
                        </div>
                      </td>

                      <!-- confirm qty -->
                      <td>
                        <div style="width: 70px">
                          <v-text-field
                            v-model="props.item.confirmQty"
                            min="0"
                            @input="subtotalChange()"
                            :rules="rules.confirmQtyRules"
                            :readonly="
                              user.roleName == 'SALE' && !!orderHeader.id
                            "
                          ></v-text-field>
                        </div>
                      </td>

                      <!-- sale qty -->
                      <td>
                        <div style="width: 70px">
                          <v-text-field
                            v-model="props.item.saleQty"
                            min="0"
                            readonly
                          ></v-text-field>
                        </div>
                      </td>

                      <!-- unit price -->
                      <td>
                        <div style="width: 70px">
                          <v-text-field
                            v-model="props.item.price"
                            min="0"
                            @input="subtotalChange()"
                            :rules="rules.unitPriceRules"
                            :readonly="
                              user.roleName == 'SALE' && !!orderHeader.id
                            "
                          ></v-text-field>
                        </div>
                      </td>

                      <!-- totao price -->
                      <td>
                        {{ props.item.totalPrice | decFormat(6) }}
                      </td>

                      <!-- discount -->
                      <td>
                        <v-text-field
                          v-model="props.item.discountPercent"
                          min="0"
                          max="100"
                          type="number"
                          @input="subtotalChange()"
                          :rules="rules.discountPercentRules"
                          :disabled="!isItemDiscount"
                          :readonly="user.role.roleName == 'WAREHOUSE_MANAGER' || user.role.roleName == 'WARERHOUSE_STAFF'"
                        ></v-text-field>
                      </td>

                      <!-- actions -->
                      <td>
                        <v-btn
                          icon
                          @click="removeProduct(props.item.id)"
                          :disabled="
                            btnDisabled || !props.item.isNew || 
                            ((user.roleName == 'WAREHOUSE_MANAGER' || user.roleName == 'WAREHOUSE_STAFF') &&
                              !!orderHeader.id)
                          "
                        >
                          <v-icon>cancel</v-icon>
                        </v-btn>

                        <!--<v-btn
                          v-if="!props.item.isNew"
                          icon
                          @click="updateOrderDetail(props.item)"
                          :disabled="
                            btnDisabled ||
                            ((user.roleName == 'WAREHOUSE_MANAGER' || user.roleName == 'WAREHOUSE_STAFF') &&
                              !!orderHeader.id)
                          "
                          :loading="orderDetailLoading"
                        >
                          <v-icon color="success">edit</v-icon>
                        </v-btn>-->
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
    <!-- Customer list dialog -->
    <v-dialog v-model="showCustomerListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout class="pa-3">
            <v-flex sm2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                v-model="customerQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm2 pl-1>
              <v-text-field
                name="name"
                label="Customer Name"
                type="text"
                v-model="customerQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm2 pl-1>
              <v-text-field
                name="email"
                label="Customer Email"
                type="text"
                v-model="customerQueryParams.email"
              ></v-text-field>
            </v-flex>
            <v-flex sm2 pl-1>
              <v-select
                :items="creditLevelList"
                v-model="customerQueryParams.creditLevelId"
                label="Choose Credit Level"
                item-text="name"
                item-value="id"
                menu-props="auto"
              ></v-select>
            </v-flex>
            <v-flex sm2 pl-1>
              <v-text-field
                name="township"
                label="TownShip"
                type="text"
                v-model="customerQueryParams.township"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="customerOnSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Customer List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="customerList"
                class="elevation-1"
                :loading="showCustomerListLoading"
                :total-items="customerTotalRows"
                :rows-per-page-items="customerRowsPerPageItems"
                :pagination.sync="customerPagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td @click="setCustomer(props.item)">
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.email }}</td>
                  <td>{{ props.item.phoneNo }}</td>
                  <td>{{ props.item.creditLevel.name }}</td>
                  <td>
                    {{
                      props.item.updatedDateInMilliSeconds | formatMsDateTime
                    }}
                  </td>
                  <td>{{ props.item.updatedBy }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Product list dialog -->
    <v-dialog v-model="showProductListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Product Code"
                type="text"
                class="mr-1"
                v-model="queryParams.productCode"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Product Name"
                type="text"
                class="mr-1"
                v-model="queryParams.productName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="brandName"
                label="Brand Name"
                type="text"
                class="mr-1"
                v-model="queryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="categoryName"
                label="Category Name"
                type="text"
                class="mr-1"
                v-model="queryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="productGroupName"
                label="Product Group Name"
                type="text"
                class="mr-1"
                v-model="queryParams.productGroupName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-data-table
              :headers="productHeaders"
              :items="productList"
              class="elevation-1"
              :loading="showListLoading"
              :total-items="totalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              :must-sort="true"
            >
              <template slot="items" slot-scope="props">
                <td
                  @click="
                    setProduct(props.item.code, selectedId),
                      (showProductListDialog = !showProductListDialog)
                  "
                >
                  <a>{{ props.item.code }}</a>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.brand.name }}</td>
                <td>{{ props.item.category.name }}</td>
                <td v-if="props.item.productGroup">
                  {{ props.item.productGroup.name }}
                </td>
                <td v-else></td>
                <td>{{ props.item.description }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- customer add dialog -->
    <customer-add-dialog
      :showDialog="customerAddDialog"
      @close="closeCustomerDialog"
    />
  </v-container>
</template>
<script>
import { orderService } from "../../services/order-service";
import { OrderFormRules } from "../../helpers/validation-rules";
import { OrderHeader } from "../../models/model";
import { OrderHeadDetail } from "../../models/model";
import { customerService } from "../../services/customer-service";
import { creditLevelService } from "../../services/credit-level-service";
import { shopService } from "../../services/shop-service";
import { warehouseService } from "../../services/warehouse-service";
import { cityService } from "../../services/city-service";
import { commonService } from "../../services/common-service";
// import { productService } from "../../services/product-service";
import { supplierProductService } from "../../services/supplier-product-service";
import customerAddDialog from "../customer/CustomerAddDialog.vue";

export default {
  name: "OrderDetail",
  components: { customerAddDialog },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    saveLoading: false,
    btnDisabled: false,
    warehousebtnDisabled: false,
    saveWholeSale: false,
    isItemDiscount: false,
    breadcrumbs: [
      {
        text: "Order",
        disabled: false,
        to: "orders",
      },
      {
        text: "Order Detail",
        disabled: true,
      },
    ],
    orderDate: "",
    rules: new OrderFormRules(),
    csRequestDate: "",
    estDate: "",
    createdDate: "",
    updatedDate: "",
    status: "PENDING",
    orderHeader: new OrderHeader(),
    oldOrderHeader: new OrderHeader(),
    orderHeadDetail: new OrderHeadDetail(),
    customerQueryParams: {
      code: "",
      name: "",
      email: "",
      creditLevelId: "",
      township: "",
      regionId: "",
      isNoRegion: Boolean,
      status: "ACTIVE",
    },
    showCustomerListDialog: false,
    showCustomerListLoading: false,
    customerList: [],
    customerTotalRows: 0,
    creditLevelList: [],
    headers: [
      { text: "Code", align: "left", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Email", value: "email" },
      { text: "PhoneNo", value: "phoneNo" },
      { text: "Credit Level", value: "creditLevel", sortable: false },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    detailHeaders: [
      { text: "Code", align: "left", value: "code", sortable: false },
      { text: "Product", align: "left", value: "name", sortable: false },
      { text: "Unit", align: "left", value: "factorUnit", sortable: false },
      /*{
        text: "Available Qty",
        align: "left",
        value: "availableQty",
        sortable: false,
      },*/
      { text: "Qty", align: "left", value: "qty", sortable: false },
      {
        text: "Confirm Qty",
        align: "left",
        value: "confirmQty",
        sortable: false,
      },
      {
        text: "Sale Qty",
        align: "left",
        value: "saleQty",
        sortable: false,
      },
      {
        text: "Unit Price",
        align: "left",
        value: "unitPrice",
        sortable: false,
      },
      {
        text: "Total Price",
        align: "left",
        value: "totalPrice",
        sortable: false,
      },
      { text: "Discount", align: "left", value: "discount", sortable: false },
      { text: "Action", value: "action", sortable: false },
    ],
    detailCodeSearch: "",
    customerRowsPerPageItems: [25, 50, 100],
    customerPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    shopList: [],
    cityList: [],
    townshipList: [],
    subtotalAmount: 0,
    decimalFormat: "",
    queryParams: {
      productName: "",
      productCode: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: "",
      regionId: "",
      isSale: true,
      binIds: [],
      orderWarehouseId: "",
      orderEditId: "",
      pricemodelId: "",
    },
    showProductListDialog: false,
    showListLoading: false,
    productList: [],
    regionId: "",
    totalRows: 0,
    warehouseList: [],
    productHeaders: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" },
    ],
    rowsPerPageItems: [10, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0,
    },
    responseError: "",
    statusList: [
      { label: "PENDING", value: "PENDING" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    isDiscountPercentage: false,
    isPromotionPercentage: false,

    customerAddDialog: false,

    //orderDetailLoading: false,
  }),

  computed: {
    detailList() {
      return this.orderHeader.orderHeadDetails.filter((d) => {
        if (this.detailCodeSearch)
          return (
            d.productDTO.code
              .toLowerCase()
              .indexOf(this.detailCodeSearch.toLowerCase()) > -1
          );
        else return true;
      });
    },
  },

  watch: {
    customerPagination: {
      handler() {
        this.getCustomerList();
      },
      deep: true,
    },
    pagination: {
      handler() {
        this.getProductList();
      },
      deep: true,
    },
    isItemDiscount: {
      handler() {
        this.toggleDiscount();
      },
      deep: true,
    },
  },
  created() {
    if (this.user.roleName == "SALE") {
      this.statusList = [
        { label: "PENDING", value: "PENDING" },
        { label: "CANCEL", value: "CANCEL" },
      ];
    }
    if (
      this.user.role.roleName == "GENERAL_MANAGER" ||
      this.user.role.roleName == "SALE_MANAGER" ||
      this.user.role.roleName == "SALE"
    ) {
      this.regionId = this.user.shop.regionId;
      this.queryParams.binIds = this.user.shop.binIds;
    }
    if (this.user.role.roleName == 'BRANCH_ADMIN') {
      this.orderHeader.shopId = this.user.shopId;
      this.orderHeader.warehouseId = this.user.warehouseId;
    }
    this.getCreditLevels();
    this.getShop();
    this.getAllCity();
    this.decimalFormat = commonService.formatdecimal();
    const id = this.$route.params.id;
    if (id == "new") {
      this.addProduct();
      this.orderDate = commonService.formatDate(
        new Date().toISOString().substr(0, 10),
        "YYYY-MM-DD"
      );
    } else {
      this.getOrderDetail(id);
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getOrderDetail(id) {
      orderService
        .getOrderDetail(id)
        .then((res) => {
          this.orderHeader = res.data;

          this.isItemDiscount = this.orderHeader.isItemDiscount;

          if (this.orderHeader) {
            if (this.orderHeader.discountPercent > 0) {
              this.isDiscountPercentage = true;
            }
            if (this.orderHeader.promotionPercent > 0) {
              this.isPromotionPercentage = true;
            }
          }
          this.createdDate = commonService.formatDate(
            new Date(this.orderHeader.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.orderHeader.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.status = this.orderHeader.orderStatus;
          this.saveWholeSale = this.orderHeader.isSaveInWholeSale;
          if (this.status == "CONFIRM" || this.status == "CANCEL") {
            this.btnDisabled = true;
          }
          if (this.user.roleName == "WAREHOUSE_MANAGER") {
            this.warehousebtnDisabled = true;
          }
          this.orderDate = commonService.millisecondToDate(
            this.orderHeader.orderDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.csRequestDate = commonService.millisecondToDate(
            this.orderHeader.csRequestDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.estDate = commonService.millisecondToDate(
            this.orderHeader.estimateDeliveryDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.getTownshipByCityId(this.orderHeader.cityId);
          this.regionId = this.orderHeader.shopDTO.regionId;
          this.queryParams.binIds = this.orderHeader.shopDTO.binIds;
          this.queryParams.orderWarehouseId = this.orderHeader.warehouseId;
          this.queryParams.orderEditId = this.orderHeader.id;
          if (this.orderHeader.customerDTO.priceModelId) {
            this.queryParams.pricemodelId =
              this.orderHeader.customerDTO.priceModelId;
          }
          this.subtotalChange();
          // deep copy
          this.oldOrderHeader = JSON.parse(JSON.stringify(res.data));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getRegionbyShop() {
      this.warehouseList = [];
      let shop = commonService.search(
        "id",
        this.orderHeader.shopId,
        this.shopList
      );
      if (shop) {
        this.regionId = shop.regionId;
        this.queryParams.binIds = shop.binIds;
         this.orderHeader.warehouseId = shop.warehouse.id;
         this.warehouseList.push(shop.warehouse);
      }
      this.orderHeader.customerId = "";
      this.orderHeader.customerDTO.name = "";
      this.orderHeader.phoneNo = "";
      this.orderHeader.deliveryAddress = "";
      this.orderHeader.cityId = "";
      this.orderHeader.billingAddress = "";
      this.orderHeader.townshipId = "";
      this.orderHeader.orderHeadDetails = [];
      this.addProduct();
    },
    showCustomers() {
      // Clean query params
      this.customerQueryParams.name = "";
      this.customerQueryParams.email = "";
      this.customerQueryParams.creditLevelId = "";
      this.customerQueryParams.township = "";
      this.customerQueryParams.regionId = this.regionId;
      this.regionId
        ? (this.customerQueryParams.isNoRegion = false)
        : (this.customerQueryParams.isNoRegion = true);
      this.getCustomerList().then(
        (this.showCustomerListDialog = !this.showCustomerListDialog)
      );
    },
    customerOnSearch() {
      this.customerQueryParams.page = this.customerPagination.page;
      this.customerQueryParams.size = this.customerPagination.rowsPerPage;
      this.getCustomerList();
    },
    getCustomerList() {
      this.showCustomerListLoading = true;
      let order = this.customerPagination.descending ? "desc" : "asc";
      return customerService
        .getCustomers(
          this.customerQueryParams,
          this.customerPagination.page,
          this.customerPagination.rowsPerPage,
          this.customerPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.customerList = res.data.customerList;
            this.customerTotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.showCustomerListLoading = false;
        });
    },
    getCreditLevels() {
      creditLevelService
        .getCreditLevels()
        .then((res) => {
          if (res.data) {
            this.creditLevelList = res.data.creditLevelList;
            let findAll = {
              id: "",
              name: "----All----",
            };
            this.creditLevelList.splice(
              0,
              0,
              JSON.parse(JSON.stringify(findAll))
            );
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    setCustomer(customer) {
      this.orderHeader.customerId = customer.id;
      this.orderHeader.customerDTO.name = customer.name;
      this.orderHeader.phoneNo = customer.phoneNo;
      this.orderHeader.deliveryAddress = customer.address;
      this.orderHeader.cityId = customer.cityId;
      this.orderHeader.billingAddress = customer.address;
      this.orderHeader.townshipId = customer.townshipId;
      if (customer.priceModelId) {
        this.queryParams.pricemodelId = customer.priceModelId;
      }
      this.getTownshipByCityId(customer.cityId);
      this.showCustomerListDialog = false;
    },
    getShop() {
      if (
        this.user.roleName == "SALE_MANAGER" ||
        this.user.role.roleName == "GENERAL_MANAGER" ||
        this.user.roleName == "SALE" ||
        this.user.roleName == 'BRANCH_ADMIN'
      ) {
        shopService
          .getShopById(this.user.shop.id)
          .then((res) => {
            this.shopList.push(res.data);
            // this.shopList.forEach((element) => {
            this.orderHeader.shopId = res.data.id;
            this.orderHeader.warehouseId = res.data.warehouseId;
            this.warehouseList.push(res.data.warehouse);
            // });
          })
          .catch((err) => {
            console.log(err);
          });
      }
      if (
        this.user.roleName == "ADMIN" ||
        this.user.roleName == "WAREHOUSE_MANAGER" || 
        this.user.roleName == "WAREHOUSE_STAFF" ||
        this.user.roleName == 'BRANCH_ADMIN'
      ) {
        shopService
          .getAllShop()
          .then((res) => {
            this.shopList = res.data;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    getAllWarehouses() {
      if (
        this.user.roleName == "ADMIN" ||
        this.user.roleName == "SALE_MANAGER" ||
        this.user.role.roleName == "GENERAL_MANAGER" ||
        this.user.roleName == "SALE" ||
        this.user.role.roleName == "WAREHOUSE_MANAGER"|| 
        this.user.role.roleName == "WAREHOUSE_STAFF" || 
        this.user.roleName == 'BRANCH_ADMIN'
      ) {
        warehouseService
          .getWarehousesByStatus("ACTIVE")
          .then((res) => {
            this.warehouseList = res.data;
          })
          .catch((err) => {
            console.log(err);
          });
      }
      /*if (
        this.user.roleName == "SALE_MANAGER" ||
        this.user.roleName == "WAREHOUSE_MANAGER"
      ) {
        let warhouseId = "";
        if (this.user.roleName == "SALE_MANAGER") {
          warhouseId = this.user.shop.warehouseId;
        } else {
          warhouseId = this.user.warehouse.id;
        }
        warehouseService
          .getWarehouseDetail(warhouseId)
          .then((res) => {
            this.warehouseList.push(res.data);
            this.warehouseList.forEach((element) => {
              this.orderHeader.warehouseId = element.id;
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }*/
    },
    getAllCity() {
      cityService.getAllCity().then((res) => {
        this.cityList = res.data.cityList;
      });
    },
    getTownshipByCityId(cityId) {
      cityService
        .getCityDetail(cityId)
        .then((res) => {
          this.townshipList = res.data.townships;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.orderHeader.id) {
        this.orderHeader = new OrderHeader();
        this.csRequestDate = "";
        this.estDate = "";
        this.addProduct();
        this.subtotalAmount = 0;
      } else {
        this.orderHeader = Object.assign({}, this.oldOrderHeader);
        this.orderDate = commonService.formatDate(
          new Date(this.oldOrderHeader.orderDateInMilliSeconds)
            .toISOString()
            .substr(0, 10),
          "YYYY-MM-DD"
        );
        this.csRequestDate = commonService.millisecondToDate(
          this.orderHeader.csRequestDateInMilliSeconds,
          "YYYY-MM-DD"
        );
        this.estDate = commonService.millisecondToDate(
          this.orderHeader.estimateDeliveryDateInMilliSeconds,
          "YYYY-MM-DD"
        );
        this.subtotalChange();
      }
    },
    addProduct() {
      // deep copy
      orderDetail = new OrderHeadDetail();
      let orderDetail = JSON.parse(JSON.stringify(this.orderHeadDetail));

      // if no id, add temporary id for key
      if (!orderDetail.id) {
        orderDetail.isNew = true;
        let duplicateFlag = true;
        let id;

        // generate random id until it's unique
        while (duplicateFlag) {
          id = Math.floor(Math.random() * 9999 + 1);

          // find if id is duplicated
          let duplicateDetail = this.orderHeader.orderHeadDetails.find(
            (d) => d.id == id
          );
          if (!duplicateDetail) duplicateFlag = false;
        }

        orderDetail.id = id;
      }

      this.orderHeader.orderHeadDetails.unshift(orderDetail);
    },
    removeProduct(orderDetailId) {
      const index = this.orderHeader.orderHeadDetails
        .map((d) => d.id)
        .indexOf(orderDetailId);

      if (!this.orderHeader.orderHeadDetails[index].isNew) {
        // add delete purchaseOrderItem id
        if (!this.orderHeader.deleteOrderDetailIds) {
          this.orderHeader.deleteOrderDetailIds = [];
        }
        this.orderHeader.deleteOrderDetailIds.push(orderDetailId);
      }
      this.$delete(this.orderHeader.orderHeadDetails, index);
      this.subtotalChange();
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getProductList();
    },
    showProducts() {
      // Clean query params
      this.queryParams.productCode = "";
      this.queryParams.productName = "";
      this.queryParams.brandName = "";
      this.queryParams.categoryName = "";
      this.queryParams.productGroupName = "";
      this.queryParams.regionId = this.regionId;
      this.queryParams.orderWarehouseId = this.orderHeader.warehouseId;
      this.getProductList().then(
        (this.showProductListDialog = !this.showProductListDialog)
      );
    },
    getProductList() {
      var this_ = this;
      this_.showListLoading = true;
      this_.productList = [];
      return supplierProductService
        .getAllProductBySupplierAndWarehouse(
          this_.queryParams,
          this_.pagination.page,
          this_.pagination.rowsPerPage
        )
        .then((res) => {
          if (res.data) {
            this_.productList = res.data.productList;
            this_.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this_.showListLoading = false;
        });
    },
    setProduct(code, id) {
      let product = commonService.search("code", code, this.productList);

      const index = this.orderHeader.orderHeadDetails
        .map((d) => d.id)
        .indexOf(id);

      this.orderHeader.orderHeadDetails[index].productId = product.id;
      this.orderHeader.orderHeadDetails[index].productDTO.code = product.code;
      this.orderHeader.orderHeadDetails[index].productName = product.name;

      // set default unit
      var j = 0;
      for (var i = 0; i < product.productUnits.length; i++) {
        if (product.productUnits[i].basicUnit == true) j = i;
      }
      this.orderHeader.orderHeadDetails[index].factorUnitName =
        product.productUnits[j].factorUnitName;
      this.orderHeader.orderHeadDetails[index].productUnits =
        product.productUnits;
      /*this.orderHeader.orderHeadDetails[index].orderQty =
        product.productUnits[j].qty;*/
      this.orderHeader.orderHeadDetails[index].price =
        product.productUnits[j].wholeSaleSellingPrice;
      this.orderHeader.orderHeadDetails[index].discountPercent =
        product.productUnits[j].wholeSaleSellingPricePercentage;
      this.orderHeader.orderHeadDetails[index].productUnitId =
        product.productUnits[j].id;
      this.orderHeader.orderHeadDetails[index].availableQty =
        product.productUnits[j].qty;
      this.subtotalChange();
    },
    initPrice(factorUnitName, id) {
      const index = this.orderHeader.orderHeadDetails
        .map((d) => d.id)
        .indexOf(id);

      let productUnit = commonService.search(
        "factorUnitName",
        factorUnitName,
        this.orderHeader.orderHeadDetails[index].productUnits
      );

      this.orderHeader.orderHeadDetails[index].price =
        productUnit.wholeSaleSellingPrice;
      this.orderHeader.orderHeadDetails[index].discountPercent =
        productUnit.wholeSaleSellingPricePercentage;
      this.orderHeader.orderHeadDetails[index].productUnitId = productUnit.id;
      this.orderHeader.orderHeadDetails[index].availableQty = productUnit.qty;
      this.subtotalChange();
    },
    subtotalChange() {
      this.subtotalAmount = 0;
      this.orderHeader.orderHeadDetails.forEach((item) => {
        if (this.isItemDiscount && item.discountPercent > 0) {
          let discount = (item.price * (item.discountPercent / 100)).toFixed(6);
          discount = parseFloat(discount);
          item.totalPrice = Number(
            parseFloat(item.confirmQty * (item.price - discount)).toFixed(6)
          );
        } else {
          item.totalPrice = item.confirmQty * item.price;
        }
        this.subtotalAmount += item.totalPrice;
      });
    },
    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          this.saveLoading = true;
          this.orderHeader.orderStatus = this.status;
          if (this.orderHeader.id && this.saveWholeSale) {
            this.orderHeader.isSaveInWholeSale = this.saveWholeSale;
          } else this.orderHeader.isSaveInWholeSale = false;
          if (!this.orderHeader.id) this.orderHeader.userId = this.user.id;
          //convert to millisecond
          this.orderHeader.csRequestDateInMilliSeconds =
            commonService.convertToMilliseconds(this.csRequestDate);
          this.orderHeader.estimateDeliveryDateInMilliSeconds =
            commonService.convertToMilliseconds(this.estDate);
          //convert to millisecond
          this.orderHeader.orderDateInMilliSeconds =
            commonService.convertToMilliseconds(this.orderDate);

          // deep copy and remove unecessary objects
          let order = JSON.parse(JSON.stringify(this.orderHeader));
          order.cityDTO = null;
          order.approvedUserDTO = null;
          order.customerDTO = null;
          order.townshipDTO = null;
          order.shopDTO = null;
          order.userDTO = null;
          order.orderHeadDetails.forEach((detail) => {
            detail.productDTO = null;
            detail.productUnitDTO = null;
            detail.productUnits = null;
            if (detail.isNew) detail.id = null;
          });

          orderService
            .saveOrder(order)
            .then((res) => {
              if (this.user.roleName != "SALE") {
                this.$emit("changeOrderCount", true);
              }
              if (res) {
                this.goBack();
              }
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
              }
              this.saveLoading = false;
            });
        }
      }
    },
    changeDiscountSwitch() {
      this.orderHeader.discountAmount = 0;
      this.orderHeader.discountPercent = 0;
    },
    changePromotionSwitch() {
      this.orderHeader.promotionAmount = 0;
      this.orderHeader.promotionPercent = 0;
    },
    clearOrderDetail() {
      this.orderHeader.orderHeadDetails = [];
      this.addProduct();
    },
    toggleDiscount() {
      if (this.isItemDiscount) {
        this.orderHeader.isItemDiscount = true;
      } else {
        this.orderHeader.isItemDiscount = false;
      }
      this.subtotalChange();
    },

    addNewCustomer() {
      this.customerAddDialog = !this.customerAddDialog;
    },

    closeCustomerDialog(customer) {
      this.customerAddDialog = !this.customerAddDialog;
      if (customer.id) {
        this.setCustomer(customer);
      }
    },

    /*updateOrderDetail(orderDetail) {
      if (this.status == "PENDING") {
        this.orderDetailLoading = true;

        orderService
          .updateOrderDetail(orderDetail)
          .then(() => {
            //
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
          })
          .finally(() => {
            this.orderDetailLoading = false;
          });
      }
    },*/
  },
};
</script>
